import { hideModal, modalBodyType } from '@/redux/navigationSlice';
import { RootState } from '@/redux/store';
import { type IconBadgeTone, type MaterialIconType, Modal } from '@repo/ui';
import { useDispatch, useSelector } from 'react-redux';
import { BackToStoreBody } from './backToStoreBody';
import { ModalCancelBody } from './cancelBody';
import { SelectedPlanBody } from './selectedPlanBody';

const bodySelector = (body: modalBodyType) => {
  switch (body) {
    case 'selectedPlan':
      return <SelectedPlanBody />;
    case 'cancel':
      return <ModalCancelBody />;
    case 'backToStore':
      return <BackToStoreBody />;
    default:
      return <></>;
  }
};

// Dialog icons, same as customer-mobile: concentric rings above the title
const iconSelector = (body: modalBodyType): { icon: MaterialIconType; tone: IconBadgeTone } | null => {
  switch (body) {
    case 'cancel':
      return { icon: 'warning', tone: 'warning' };
    case 'backToStore':
      return { icon: 'storefront', tone: 'warning' };
    case 'selectedPlan':
      return { icon: 'calendar_month', tone: 'brand' };
    default:
      return null;
  }
};

/**
 * Renders a Modal component with title and body based on redux.
 *
 * @return {React.JSX.Element} The rendered Modal component.
 */
export const OnbModal = () => {
  const modalData = useSelector((state: RootState) => state.navigationdata.modalData);
  const dispatch = useDispatch();
  const { open, body, title, onClose } = modalData;
  const BodyComponent = bodySelector(body);
  const icon = iconSelector(body);
  const handleClose = () => {
    dispatch(hideModal());
    onClose?.();
  };
  return (
    <Modal open={open} onClose={handleClose} heading={title} icon={icon}>
      {BodyComponent}
    </Modal>
  );
};
